if (!customElements.get('ss-lazy-video')) {
  customElements.define('ss-lazy-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('button')?.addEventListener('click', () => {
        this.hydrate();
        this.video?.play().catch(() => {});
      }, {signal: this.controller.signal});
      this.observer = new IntersectionObserver(entries => {
        const visible = entries[0].isIntersecting;
        if (visible && !this.reducedMotion) this.hydrate();
        if (!this.video || !this.hasAttribute('data-autoplay')) return;
        if (visible && !this.reducedMotion) this.video.play().catch(() => {});
        else this.video.pause();
      }, {threshold: 0.05});
      this.observer.observe(this);
    }
    hydrate() {
      if (this.video) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.video = template.content.querySelector('video');
      if (!this.video) return;
      const poster = this.querySelector('button');
      template.replaceWith(this.video);
      poster?.remove();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}
